import { Bus } from './bus.js'

export const sphereSetup = {
  id: 'default',
  bus: Bus.i,
  stylesheets: '/lib/foundation/',
  stydefault: ['stylesheets:oiddefault.css'],
  assets: '/assets/'
}